import { trackEvent } from './analytics/analytics'
import { TRACK_EVENTS } from '../constants'

// Pre-auth, anonymous funnel ping fired when the user clicks "Forgot password?" on the login
// screen. No userId/email yet (identify only runs after a successful login), so the event is
// keyed to Segment's anonymousId and carries only the platform stamp.
export const trackForgotPasswordClicked = () => trackEvent(TRACK_EVENTS.LOGIN_FORGOT_PASSWORD, { platform: 'web' })
